import type {
  LeagueInfo,
  LeagueProjectionAttributes
} from '@library/types/leagues';
import type { LeagueGames } from '@library/types/games';
import { useMemo } from 'react';

export const useBoardBuilder = ({
  bulkLeagueIdGroups,
  durations,
  games,
  leagueInfo,
  searchValue,
  selectedDate,
  selectedDuration,
  selectedGames,
  selectedPositions,
  selectedTeams
}: {
  bulkLeagueIdGroups: Array<Array<string>>;
  durations: Array<LeagueProjectionAttributes>;
  games: LeagueGames;
  leagueInfo: LeagueInfo;
  searchValue: string;
  selectedDate: string;
  selectedDuration: string;
  selectedGames: Array<string>;
  selectedPositions: Array<string>;
  selectedTeams: Array<string>;
}) => {
  const boardBuilderContext = useMemo(() => {
    return {
      bulkLeagueIdGroups,
      durations,
      games,
      leagueInfo,
      searchValue,
      selectedDate,
      selectedDuration,
      selectedGames,
      selectedPositions,
      selectedTeams
    };
  }, [
    bulkLeagueIdGroups,
    durations,
    games,
    leagueInfo,
    searchValue,
    selectedDate,
    selectedDuration,
    selectedGames,
    selectedPositions,
    selectedTeams
  ]);

  return {
    boardBuilderContext
  };
};
